import React from 'react';
import { addDays, format, isSameDay, parseISO, startOfWeek } from 'date-fns';
import { es } from 'date-fns/locale';
import { Link } from 'react-router-dom';
import type { Audiencia } from '../../types';
import { HOY } from '../../utils/fechas';
export function MiniSemana({
  audiencias
}: {
  audiencias: Audiencia[];
}) {
  const inicio = startOfWeek(HOY, {
    weekStartsOn: 1
  });
  const dias = Array.from({
    length: 7
  }).map((_, i) => addDays(inicio, i));
  return <div className="px-4 py-4" data-id="element-176" data-mp="2wbno1ruufmer">
      <div className="grid grid-cols-7 gap-1.5" data-id="element-177" data-mp="30fvh218c3ois">
        {dias.map(dia => {
        const delDia = audiencias.filter(a => isSameDay(parseISO(a.fecha), dia)).sort((a, b) => a.hora.localeCompare(b.hora));
        const esHoy = isSameDay(dia, HOY);
        return <div key={dia.toISOString()} className={`min-h-[9.5rem] rounded border px-1.5 py-1.5 ${esHoy ? 'border-marino-600 bg-marino-50' : 'border-gris-200 bg-white'}`} data-id="element-178" data-mp="1azw0hz2dywt4">
              <p className={`text-2xs font-semibold uppercase ${esHoy ? 'text-marino-700' : 'text-gris-400'}`} data-id="element-179" data-mp="ln2snx7dx7h6">
                {format(dia, 'EEE', {
              locale: es
            })}
              </p>
              <p className={`tabular text-base font-semibold leading-tight ${esHoy ? 'text-marino-800' : 'text-gris-700'}`} data-id="element-180" data-mp="qlcp0b4uie4d">
                {format(dia, 'dd')}
              </p>
              <ul className="mt-1.5 space-y-1" data-id="element-181" data-mp="10jthjcjfn0sj">
                {delDia.slice(0, 3).map(a => <li key={a.id} data-id="element-182" data-mp="1eaoup10ys41x">
                    <Link to={`/expedientes/${a.expedienteId}`} className={`block rounded px-1 py-0.5 text-2xs leading-tight transition-colors duration-150 ${a.tipo === 'Audiencia' ? 'bg-marino-800 text-white hover:bg-marino-700' : 'bg-ambar-50 text-ambar-700 hover:bg-ambar-100'}`} title={`${a.hora} · ${a.titulo} · ${a.lugar}`} data-id="element-183" data-mp="19cdiijn75hgj">
                      <span className="tabular font-semibold" data-id="element-184" data-mp="20bfd0ia5xp9l">{a.hora}</span>{' '}
                      <span className="line-clamp-2" data-id="element-185" data-mp="252dvnoimizg0">{a.titulo}</span>
                    </Link>
                  </li>)}
                {delDia.length > 3 && <li className="px-1 text-2xs text-gris-400" data-id="element-186" data-mp="2a3tkzsru3s47">+{delDia.length - 3} más</li>}
              </ul>
            </div>;
      })}
      </div>
      <div className="mt-3 flex items-center gap-4 text-2xs text-gris-500" data-id="element-187" data-mp="2j2ydoigpsr8g">
        <span className="flex items-center gap-1.5" data-id="element-188" data-mp="2o0gq4itxxol7">
          <span className="h-2 w-2 rounded-sm bg-marino-800" aria-hidden="true" data-id="element-189" data-mp="2nz5n4l8bkkv5" /> Audiencia
        </span>
        <span className="flex items-center gap-1.5" data-id="element-190" data-mp="tnh6memfwa8n">
          <span className="h-2 w-2 rounded-sm bg-ambar-400" aria-hidden="true" data-id="element-191" data-mp="toa6qwqw81ht" /> Cita
        </span>
      </div>
    </div>;
}